// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
import { Permission } from './permissions.js';
/** The owning module's read grant protects a caption everywhere it can appear. */
export const RECORD_LINK_TARGET_READ_GRANTS = {
    vendor: Permission.GOV_VENDOR_READ,
    vendor_questionnaire: Permission.VENDOR_QUESTIONNAIRE_READ,
    ai_system: Permission.AI_GOVERNANCE_READ,
    ai_system_version: Permission.AI_GOVERNANCE_READ,
    ai_classification_run: Permission.AI_GOVERNANCE_READ,
    processing_activity: Permission.DM_ACTIVITY_READ,
    dpia: Permission.DPIA_READ,
    incident: Permission.INCIDENT_READ,
    evidence: Permission.DM_EVIDENCE_READ,
    data_map_system: Permission.DM_SYSTEM_READ,
    vehicle_monitoring_device: Permission.VEHICLE_MONITORING_READ,
};
export function formRecordLinkSection(type) {
    return `form_link_${type}`;
}
//# sourceMappingURL=record-link-access.js.map